// @ts-nocheck
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { rtkQueryErrorLogger } from 'utils/store-middleware';
import { caseTypeApi } from 'services/case-type/case-type-api';
import { dataSetApi } from 'services/data-set/data-set-api';
import { pcodesApi } from 'services/pcodes/pcodes-api';
import { userContextApi } from 'services/user-context/user-context-api';

let store;

export default function getStore() {
  if (!store) {
    store = configureStore({
      reducer: {
        // Add the generated reducer as a specific top-level slice
        [caseTypeApi.reducerPath]: caseTypeApi.reducer,
        [dataSetApi.reducerPath]: dataSetApi.reducer,
        [pcodesApi.reducerPath]: pcodesApi.reducer,
        [userContextApi.reducerPath]: userContextApi.reducer,
      },
      // Adding the api middleware enables caching, invalidation, polling,
      // and other useful features of `rtk-query`.
      middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
          caseTypeApi.middleware,
          dataSetApi.middleware,
          pcodesApi.middleware,
          userContextApi.middleware,
          rtkQueryErrorLogger
        ),
    });
    // optional, but required for refetchOnFocus/refetchOnReconnect behaviors
    // see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
    setupListeners(store.dispatch);
  }
  return store;
}
